<template>
	<v-modal
		:is-open="isOpen"
		type="reviews"
		class="bg-white"
		@close="$emit('close')"
	>
		<v-modal-header @close="$emit('close')">
			{{ t("review-title") }}
		</v-modal-header>

		<div class="px-lg pb-20">
			<p class="text-base tracking-xl text-gray-900">
				{{ story?.content.reviews_ingress }}
			</p>

			<v-page-product-rating-widget :sku="sku" :skus="skus" />
		</div>
	</v-modal>
</template>

<script lang="ts" setup>
import {useStoryblokStory} from "@pkg/shared/composables/use-storyblok-story";

defineProps<{
	isOpen: boolean;
	sku: string;
	skus: string[];
}>();

defineEmits<{
	(event: "close"): void;
}>();

const {t} = useI18n();

const {data: story} = useStoryblokStory("global/reviews");
</script>

<i18n lang="json">
{
	"et": {
		"review-title": "Arvustused"
	},
	"fi": {
		"review-title": "Arvostelut"
	}
}
</i18n>
